import {UFBNoticeButton} from '@udemy-v2/organization-growth';
import styles from './teams-purchase-slider-menu-content.module.scss';
import {useUbCtaParams} from '@/features/course-landing-page/hooks/use-ub-cta-href';

export const TeamsPurchaseSliderMenuContent = () => {
    const {ubHref} = useUbCtaParams();
    return <UFBNoticeButton className={styles.button} href={ubHref} size={'large'} />;
};
